export default {
      id: "icon-gunluk-temizlik-usage",
      viewBox: "0 0 547.1 510.2",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-gunluk-temizlik",
      toString: function () {
        return this.url;
      }
    }